import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { C } from "../../constants/theme";

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [phase, setPhase] = useState("idle"); // idle | out | in
  const firstRender = useRef(true);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (firstRender.current) { firstRender.current = false; return; }
    if (prevPath.current === location.pathname) return;
    prevPath.current = location.pathname;

    const hash = location.hash;
    setPhase("out");
    const t1 = setTimeout(() => {
      const target = hash && document.getElementById(hash.slice(1));
      if (target) target.scrollIntoView({ behavior: "auto", block: "start" });
      else window.scrollTo({ top: 0, behavior: "auto" });
      setPhase("in");
    }, 260);
    const t2 = setTimeout(() => setPhase("idle"), 580);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [location.pathname]);

  return (
    <>
      {phase !== "idle" && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 300,
          background: C.cream,
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          opacity: phase === "out" ? 1 : 0,
          transition: "opacity 0.32s ease",
          pointerEvents: "none",
        }}>
          <div style={{ fontSize: 46, animation: "pageTransitionBounce 0.7s ease-in-out infinite" }}>🌙</div>
          <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
            {C.rainbow.slice(0, 4).map((c, i) => (
              <div key={i} style={{
                width: 10, height: 10, borderRadius: "50%", background: c,
                animation: `pageTransitionDot 0.9s ease-in-out ${i * 0.12}s infinite`,
              }} />
            ))}
          </div>
          <style>{`
            @keyframes pageTransitionBounce { 0%,100%{ transform: translateY(0); } 50%{ transform: translateY(-10px); } }
            @keyframes pageTransitionDot { 0%,100%{ transform: translateY(0); opacity:0.45; } 50%{ transform: translateY(-8px); opacity:1; } }
          `}</style>
        </div>
      )}
      <div style={{
        opacity: phase === "out" ? 0 : 1,
        transform: phase === "out" ? "translateY(10px)" : "translateY(0)",
        transition: phase === "idle" ? "none" : "opacity 0.35s ease, transform 0.35s ease",
      }}>
        {children}
      </div>
    </>
  );
};

export default PageTransition;
